/**
 * Import required libraries
 */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useIcon } from "Utils";

/**
 * Import required elements
 */
import ThisGroupRender from "./render";

/**
 * ThisGroup Component
 */
function ThisGroup(props) {
  const { logoFile, timestamp, style, backgroundColor } = props;
  // const { faviconFile, headTitle} = props;

  const [groupName, setGroupName] = useState(null);
  const [notFound, setNotFound] = useState(false);

  //----------------------------------------logo-----------------------------------------
  let fileUid = logoFile ? logoFile.uid : null
  const logo = useIcon(fileUid, timestamp);

  useEffect(() => {
    if (!logo && props.groupName) {
      setGroupName(props.groupName);
    }
    setNotFound(prev => {
      if (logo && prev) return false
      else return prev
    })
  }, [logo, props.groupName]);


  // //--------------------------------------favicon-----------------------------------------

  // let faviconFileUid = faviconFile ? faviconFile.uid : null
  // const favicon = useIcon(faviconFileUid, timestamp);

  // useEffect(() => {
  //   if(favicon) {
  //     //console.log("triggered phase 1")
  //     var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  //     //console.log("value of link.href :", link.href)
  //     //if(link.href !== favicon) {
  //       console.log("triggered phase 2")
  //       link.type = 'image/x-icon';
  //       link.rel = 'shortcut icon';
  //       link.href = favicon;
  //       document.getElementsByTagName('head')[0].appendChild(link);
  //     //}
  //   }
  // }, [favicon])

  // //---------------------------------------headtitle---------------------------------------------

  // useEffect(() => {
  //   if(headTitle) {
  //     document.title = headTitle
  //   }
  // }, [headTitle])

  //----------------------------------------render-------------------------------------------------
  return React.createElement(ThisGroupRender, {
    logo,
    groupName,
    backgroundColor,
    notFound,
    style
  });
}

ThisGroup.propTypes = {
  lang: PropTypes.string,
  logoFile: PropTypes.object,
  //favicon: PropTypes.object,
  groupName: PropTypes.string,
  backgroundColor: PropTypes.string,
  style: PropTypes.object
};

/**
 * Export component
 */
// map redux state to props
export default connect(state => {

  let { groupUid } = state.user || {};
  let group = state.list.group[groupUid] || {};
  let { logoFile/*, faviconFile*/ } = state.simtopy || {};
  let file = logoFile ? state.list.file[logoFile.uid] : null
  let { timestamp } = file || logoFile || {};
  //let headTitle = state.locale.initTheme.headTitle
  return {
    logoFile,
    // faviconFile,
    timestamp,
    groupName: group.name,
    // headTitle
  };
})(ThisGroup);
